import { render, staticRenderFns } from "./productMain.vue?vue&type=template&id=6c9da783&scoped=true&"
import script from "./productMain.vue?vue&type=script&lang=js&"
export * from "./productMain.vue?vue&type=script&lang=js&"
import style0 from "./productMain.vue?vue&type=style&index=0&id=6c9da783&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9da783",
  null
  
)

export default component.exports